import gql from 'graphql-tag';

export default gql`
fragment CouponListItem on Coupon {
    id
    name
    active_from
    active_to
    type
    applied_to
    is_free_shipping
    is_active
    usage_count
    is_combinable
    created_at
    updated_at
    generated_codes_count
    used_codes_count
    codes(first: 9999) {
        data {
            usage_count
        }
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/CouponListItem.ts